export default {
  'selectBranch': '选择店铺',
  'noneBranch': '未查询到店铺',
  'currentCall': '当前叫号',
  'currentPeople': '当前人数',
  'estimatedTime': '预计时间',
  'orderPrompt': '美味多多,快来选购~',
  'goOrder': '去下单',
  'selectedGoods': '已选商品',
  'clearCart': '清除购物车',
  'noSelectShop': '未选择菜品',
  'editNum': '修改数量',
  'soldOut': '卖光了',
  'lifting': '差{0}元起送',
  'enterOrderQuantity': '请输入下单数量',
  orderCancel: '取消',
  confirm: '确定',
  Insufficient: '库存不足',
  purchaseLimit: '超出限购数量',
  nullExplain: '请输入',
  reserveType: '就餐类型',
  reserveTypeTip: '请选择就餐类型',
  reserveType1: '配送',
  reserveType2: '堂食',
  reserveType3: '存餐',
  reserveTime: '预定时间',
  shopAddress: '门店地址',
  paymentType: '支付方式',
  // 请选择支付方式
  paymentTypeTip: '请选择支付方式',
  noneAccount: '无可用的挂账账户',
  shippingAddress: '配送地址',
  shippingAddressTip: '点击选择地址',
  // 请选择配送地址
  shippingAddressTip2: '请选择配送地址',
  shippingTime: '配送时间',
  shippingTimeTip: '请选择配送时间',
  // 存餐
  storage: '存餐',
  // 加热
  warm: '加热',
  name: '姓名',
  phone: '手机号',
  nameExplain: '请输入您的姓名',
  phoneExplain: '请输入手机号',
  // 请选择存餐柜
  storageCabinetTip: '请选择存餐柜',

  packageFee: '打包费',
  shippingFee: '配送费',
  // 存餐费
  storageFee: '存餐费',
  warmFee: '保温费',
  discountPriceFee: '优惠',
  totalFee: '总计',
  cardPay: '餐卡支付',

  orderRemark: '订单备注',
  orderRemarkTip: '口味、偏好等要求',
  orderSubmit: '提前预定并支付',
  selectDiscount: '选择优惠券',
  yuan: '元',
  fold: '折',
  noneMoney: '无金额门栏',
  section: '部分',
  common: '通用',
  noData: '暂无数据',
  select: '选择',
  correctPhone: '请输入正确的手机号码',
  // 确认支付
  confirmPay: '确认支付',

  paySuccess: '支付成功',
  paymentIn: '支付中……',
  payOrderSuccess: '下单成功',
  paySuccessTip: '请至取餐柜凭取餐号取餐',
  paySuccessTip2: '按需点餐 杜绝浪费 人人有责',
  paySuccessReserveTime: '用餐时间',
  payTotalFee: '支付金额',
  orderNo: '订单号',
  continueOrder: '继续点餐',
  // 查看详情
  viewDetail: '查看详情',

  scrollDeliciousBottom: '美味到底了',
  appointmentTime: '预约时间',
  orderTimeDate: '下单时间',
  noMore: '没有更多了',
  loading: '加载中',
  // 已完成
  orderStatus01: '已完成',
  // 已退款
  orderStatus02: '已退款',
  // 未支付
  orderStatus03: '未支付',
  orderStatus04: '配送中',
  orderTime: '订单时间',
  totalCount: '共{0}件',
  oneOrder: '再来一单',
  cancelOrder: '取消订单',
  cancelOrderPlaceholder: '确定要取消该订单吗?',
  repayBtn: '重新支付',
  repayOrderPlaceholder: '确定要重新支付吗？',
  confirmOneTip: '确定再来一单吗？',
  successTip: '充值成功',
  foodNumber: '取餐号',
  dishDetail: '菜品详情',
  totalDish: '共{0}项菜品',
  refundMoney: '退款金额',
  currentShopTip: '当前商户',
  shopView: '查看',
  cardInfo: '卡信息',
  employeeInfo: '员工信息',
  mainCard: '主卡',
  merchantTitle: '商户切换',
  switchTips: '切换商户后应用将会重新加载，请确认',
  accountLabel: '充值帐户',
  accountTips: '请选择充值帐户',
  moneyLabel: '充值金额',
  moneyTips: '请选择充值账户',
  rangeConfirm: '充值',
  moneyTips2: '请输入大于0的金额',
  feedCommentsTips: '亲!您还没有提过意见呐~！',
  forwardTips: '期待您的反馈！',
  feedBackText: '我要反馈',
  opinionType: '意见类型',
  branchLabel: '档口',
  problemLabel: '问题描述',
  problemPlaceholder: '请输入要反馈的意见',
  uploadPic: '上传图片',
  submitBtn: '提交',
  returnBtn: '返回',
  submitSuccessTip: '提交成功',
  secondsBack: '{0}秒后返回',
  noBranchTips: '请选择档口',
  feedBackStatus1: '新提交',
  feedBackStatus2: '已确认',
  feedDetailStatus1: '提交意见',
  feedDetailStatus2: '待确认',
  feedDetailStatus3: '处理中',
  problemSpot: '问题点',
  description: '描述',
  messageTitle: '写留言',
  messagePlaceholder: '请输入留言',
  send: '发送',
  successText: '刷新成功',
  pullingText: '下拉刷新',
  loosingText: '释放即可刷新',
  progressStatus1: '进行中',
  progressStatus2: '未开始',
  progressStatus3: '已结束',
  progressStatus4: '已提交',
  progressStatus5: '未填写',
  unlimit: '无期限',
  cutoff: ' 截止',
  minSelect: '最少选{0}个',
  maxSelect: '最多选{0}个',
  calendar: '日历',
  calendarTitle: '日期选择',
  week_一: '一',
  week_二: '二',
  week_三: '三',
  week_四: '四',
  week_五: '五',
  week_六: '六',
  week_日: '日',
  repastAddress: '就餐地点',
  completionTime: '配送完成时间',
  remark: '备注',
  attachments: '附件',
  locationTabbar1: '包间列表',
  locationTabbar2: '预定记录',
  insOutsText: '选择餐厅',
  capacity: '容纳人数',
  capacityUnit: '人',
  reserveStatus1: '立刻预定',
  reserveStatus2: '已被预定',
  reserveStatus3: '提交预定',
  reserveStatus4: '预定成功',
  reserveStatus5: '预定详情',
  reserveStatus6: '取消预定',
  recordsDateText: '用餐日期筛选',
  recordsStatusText: '预定状态',
  dinersNum: '用餐人数',
  numberId: '编号',
  accommodatePeople: '可容纳{0}人',
  reserveNameLabel: '联系人',
  reserveNamePlaceholder: '请填写联系人姓名',
  reservePhoneLabel: '联系方式',
  reservePhonePlaceholder: '请填写联系方式',
  reserveNumLabel: '预定到店人数',
  reserveNumLabel2: '就餐人数',
  reserveNumPlaceholder: '请填写预定到店人数',
  reserveTimeLabel: '预定就餐时间',
  reserveTimeLabel2: '就餐时间',
  reserveTimePlaceholder: '请填写预定就餐时间',
  reserveExtraLabel: '包间服务',
  reserveExtraPlaceholder: '请填写包间服务',
  remarkPlaceholder: '请填写备注',
  reserveBtn1: '重新预定',
  reserveBtn2: '确认预定',
  reserveBtn3: '继续预定',
  reserveBtn4: '查看预约',
  dateTimePickerTitle: '选择时间',
  noBRanch: '不清楚档口',
  loginTitle: '用户登录',
  loginAccountPlaceholder: '请输入工号',
  loginPasswordPlaceholder: '请输入密码',
  loginPhonePlaceholder: '请输入手机号',
  loginVerificationCodePlaceholder: '请输入验证码',
  loginBtn: '登录',
  loginBtnIng: '登录中',
  workshopTabbar1: '档口列表',
  workshopTabbar2: '订餐记录',
  workshopNameLabel: '预定人',
  workshopNamePlaceholder: '用户名',
  workshopRadioLabel: '成本中心',
  workshopAddress: '请选择',
  workshopTimeLabel: '日期',
  workshopTimePlaceholder: '点击选择日期',
  workshopDishLabel: '预定菜品',
  noSelectTips: '请选择预定菜品！',
  workshopTitle: '车间预定',
  updatePasswordTitle: '修改密码',
  cardPackageTitle: '订餐',
  packageFormTitle: '预定信息',
  orderInfoTitle: '订单信息',
  branchTitle: '选择档口',
  orderTitle: '订单列表',
  submitOrderTitle: '提交订单',
  mineTitle: '我的',
  addAddressTitle: '新增地址',
  orderDetailTitle: '订单详情',
  selectAddressTitle: '选择地址',
  quitSuccessTips: '退出成功',
  rangeTitle: '充值',
  homeTitle: '首页',
  reserveListTitle: '预定列表',
  reserveResultTitle: '预定结果',
  evaluationTitle: '问卷列表',
  evaluationContentTitle: '问卷内容',
  evaluationExplainTitle: '问卷提示页面',
  feedbackTitle: '意见反馈',
  submitFeedTitle: '提交反馈',
  feedDetailTitle: '反馈详情',
  changeShopTitle: '我的卡包',
  cardDetailTitle: '卡片信息',
  noPromises: '无权限',
  pageTitle: '巴斯夫点餐',
  explainSuccessTips: '问卷提交成功',
  surveySuccessTips: '感谢您对本次调研的支持',
  noStartStatusTips: '问卷调研还未开始',
  noStartSurveyTips: '本次调研问卷收集时间未开始',
  stopStatusTips: '问卷调研结束',
  stopSurveyTips: '本次调研问卷收集时间已结束',
  errorStatusTips: '访问失败',
  errorSurveyTips: '问卷不存在，访问失败',
  statusStr0: '全部',
  statusStr1: '已预定',
  statusStr2: '已取消',
  statusStr3: '已使用',
  statusStr4: '客未到清台',
  statusStr5: '已清台',
  statusStr6: '过期自动清台',
  dialogTitle1: '取消预定',
  dialogMessage: '是否取消该预定',
  cancelSuccess: '取消成功',
  cancelFinal: '取消失败',
  cancelTime: '取消时间',
  cancelReason: '取消原因',
  useTime: '使用时间',
  updateReserve: '修改预定',
  cancelReason1: '会员自己取消',
  cancelReason2: '后台CMS取消操作',
  cancelReason3: '后台取消占桌',
  cancelReason4: '客未到',
  addressTip1: '请选择楼宇',
  addressTip2: '请选择配送点',
  addressBtn: '确认地址',
  plantOrderTitle: '车间订单',
  refundStatus1: '无退款',
  refundStatus2: '退款中',
  refundStatus3: '退款失败',
  refundStatus4: '退款成功',
  refundStatus5: '部分退款中',
  refundStatus6: '部分退款失败',
  refundStatus7: '部分退款成功',
  locationTabbarTitle: '包厢预定',
  loginSuccess: '登录成功',
  passwordTitle: '修改密码',
  updatePasswordPlace: '请输入新密码',
  updating: '修改中',
  updateTips: '修改',
  passwordRules: '请输入8-16位密码(且包含大小写、特殊字符)',
  flowCrowd: '人流检测',
  scanLoginTitle: '第三方人员登录',
  getVCode: '获取验证码',
  loginToastSendSuccess: '发送成功',
  cardMoney: '餐卡余额',
  CombinedPayment: '组合支付',
  noBalance: '余额不足',
  wxPay: '微信支付',
  select_meal: '选择餐段',
  reserve_status: '配送状态',
  deliveryStr1: '待配送',
  verification: '请输入大于0的数量',
}